var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.44C0 1.05809 0.151713 0.691819 0.421765 0.421766C0.691818 0.151714 1.05809 0 1.44 0L12 0L18 5.04V22.56C18 22.9419 17.8483 23.3082 17.5782 23.5782C17.3082 23.8483 16.9419 24 16.56 24H1.44C1.05809 24 0.691818 23.8483 0.421765 23.5782C0.151713 23.3082 0 22.9419 0 22.56V1.44Z",
    fill: "#EF5350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V3.6C12 3.98191 12.1517 4.34818 12.4218 4.61823C12.6918 4.88829 13.0581 5.04 13.44 5.04H18",
    fill: "#D32F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51092 15.213H3.94872V16.9386H2.70312V11.7402H4.34592C5.76372 11.7402 6.57372 12.2952 6.57372 13.4358C6.57372 14.658 5.74092 15.213 4.51092 15.213ZM4.36092 12.6246H3.94872V14.3124H4.40652C4.52615 14.3298 4.64817 14.3192 4.76297 14.2813C4.87778 14.2435 4.98221 14.1795 5.06803 14.0943C5.15386 14.0092 5.21872 13.9053 5.25751 13.7908C5.29629 13.6763 5.30794 13.5544 5.29152 13.4346C5.29092 12.8874 4.98372 12.6246 4.36092 12.6246Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53755 16.938H7.12695V11.7402H8.44695C9.78255 11.7402 11.0575 12.168 11.0575 14.3136C11.0575 16.4274 9.83655 16.938 8.53755 16.938ZM8.62695 12.6396H8.37195V16.038H8.62695C9.30975 16.038 9.76695 15.6708 9.76695 14.3124C9.76935 12.9252 9.28155 12.6402 8.62875 12.6402L8.62695 12.6396Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2255 12.6246V13.9902H15.0411V14.883H13.2255V16.9386H11.9727V11.7402H15.4011L15.2733 12.6252L13.2255 12.6246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.3ab6e253089c38dee94444387fd935e2.svg";
export { ForwardRef as ReactComponent };